export const STEP_NAMES = [
    'personal-information',
    'business-information',
    'business-and-billing-address',
    'review-application',
    'sign-and-submit-application'
];

export const STEP_TITLES = [
    'Personal information',
    'Business information',
    'Business and billing address',
    'Review application',
    'Sign and submit application'
];

export const PERSONAL_FORM_ERRORS = {
    FIRST_NAME: 'Please enter a first name.',
    LAST_NAME: 'Please enter a last name.',
    VALID_FIRST_NAME: 'Your first name can only contain letters, spaces, apostrophes and hyphens.',
    VALID_LAST_NAME: 'Your last name can only contain letters, spaces, apostrophes and hyphens.',
    FIRST_NAME_SPACE: 'Your first name cannot start or end with a space.',
    LAST_NAME_SPACE: 'Your last name cannot start or end with a space.',
    LAST_NAME_SHORT: 'Last Name must be at least 2 characters.',
    PASSWORD: 'Please enter a password.',
    JOB_TITLE: 'Please select a job title.',
    INVALID_PASSWORD: 'All password rules have not been met.',
    MOBILE_NUMBER: 'Please enter a 10-digit Mobile number.'
};

export const BUSINESS_FORM_ERRORS = {
    ERROR_COUNTRY_NAME: 'Please select a country.',
    ERROR_BUSINESS_NAME: 'Please enter a business name.',
    ERROR_BUSINESS_NAME_SPACE: 'Your business name cannot start or end with a space.',
    ERROR_VALID_BUSINESS_NAME:
        'Your business name can only contain letters, numbers, spaces, hyphens, commas, apostrophes, brackets, and periods.',
    ERROR_TRADE_NAME_SPACE: 'Your trade name cannot start or end with a space.',
    ERROR_VALID_TRADE_NAME:
        'Your trade name can only contain letters, numbers, spaces, hyphens, commas, apostrophes, brackets, and periods.',
    ERROR_BUSINESS_PHONE_NUMBER: 'Please enter a business phone number.',
    ERROR_VALID_BUSINESS_PHONE_NUMBER: 'Please enter a 10-digit business phone number.',
    ERROR_FEDERAL_TAX_ID: 'Please enter a federal tax id.',
    ERROR_VALID_FEDERAL_TAX_ID: 'Please enter a 9 digit federal tax id.',
    ERROR_GST_IST_NUMBER: 'Please enter a  GST/HST number..',
    ERROR_VALID_GST_IST_NUMBER: 'Please enter a 9 digit GST/HST number.',
    ERROR_BUSINESS_TYPE: 'Please select a business type.',
    ERROR_SELECT_OPTION: 'Please answer yes or no.',
    ERROR_ANNUAL_BUSINESS_REVENUE: 'Please select an annual business revenue.',
    ERROR_EMPLYEE_ERROR: 'Please select number of employees.',
    ERROR_BUSINESS_TRADE_NAME: 'Please provide your Doing business as name.',
    ERROR_SALE_REPRESENTATIVE_ID: 'Please enter a 3-6 digit number.'
};

export const BUSINESS_FORM_DATA = {
    COUNTRY_LIST: ['United States', 'Canada'],
    COUNTRY_NAME: 'countryName',
    BUSINESS_TYPE: 'businessType',
    ANNUAL_REVENUE: 'annualBusinessRevenue',
    NUMBER_OF_EMPLOYEE: 'numberOfEmployess',
    IS_PAPER_LESS_BILLING: 'isPaperLessBilling',
    IS_REQUIRE_ORDER_NUMBER: 'isRequireOrderNumber',
    IS_BUSINESS_TAX_EXEMPT: 'isBusinessTaxExempt',
    IS_BUSINESS_OPERATION_FOR_YEARS: 'isBusinessOperationsForYears',
    IS_USING_PROCUREMENT_SYSTEM: 'isUsingProcurementSystem',
    SALE_REPRESENTATIVE_ID: 'saleRepresentativeId'
};

export const BUSINESS_BILLING_FORM_ERRORS = {
    ERROR_ADDRESS: 'Please enter an address.',
    ERROR_BILLING_ADDRESS: 'Please enter an address or PO box.',
    ERROR_VALID_ADDRESS: 'Please enter a valid address.',
    ERROR_VALID_BILLING_ADDRESS: 'Please enter a valid address or PO box',
    ERROR_CITY: 'Please enter a city.',
    ERROR_ZIPCODE: 'Please enter a zip code.',
    ERROR_POSTAL_CODE: 'Please enter a postal code.',
    ERROR_VALID_ZIPCODE: 'Please enter a 5-digit zip code.',
    ERROR_VALID_POSTAL_CODE: 'Please enter a 7-character postal code.',
    ERROR_STATE: 'Please select a state.',
    ERROR_PROVINCE: 'Please select a province.'
};

export const REVIEW_ERRORS = {
    ERROR_CONSENT: 'Please indicate whether or not you consent.',
    ERROR_CHECKBOX: 'Please check box to continue application.',
    E_SIGN_ERROR_MESSAGE: 'Please re-fill the form, starting from the Personal Information step.'
};

export const CCAConstant = {
    YES: 'Yes',
    NO: 'No',
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    SEVEN: 7,
    EIGHT: 8,
    NINE: 9,
    TEN: 10,
    NUMBER_FORMAT: /\D/g,
    NUMBER_ALPHABET_FORMAT: /[^a-zA-Z0-9]/g
};

export const COUNTRY = {
    US: 'US',
    ID_US: 1,
    CA: 'CA',
    ID_CA: 2,
    UNITED_STATES: 'United States',
    CANADA: 'Canada'
};

export const REVIEW_APPLICATION_ERRORS = {
    CREDIT_ENQUIRY: 'Credit inquiries agreement',
    PRIVACY_POLICY: 'Privacy Policy agreement',
    ELECTRONIC_MESSAGE: 'Consent to electronic messages and alerts'
};

export const SUBMIT_APPLICATION = {
    IS_SIGNED: 'isSigned'
};

export const VERIFY_ADDRESS_FORM_DATA = {
    NO_BUSINESS_MATCH_ON_EXPERIAN: 'noBusinessMatchOnExperian',
    BUSINESS_NAME: 'businessName'
};

export const ADDRESS_ERROR_CODE = '422';
export const FEDERAL_TAX_ID_ERROR_CODE = '0002A';
export const BUSINESS_NAME_ADDRESS_ERROR_CODE = '0008A';
export const CHANNEL = 'WEBAPP';
export const PHONE_IDENTIFIER = 'Work';

export const APPLICATION_STATUS_PATTERN = /\/(pod|cca)\/application-(status|error)(?:\.html)?(?:\/)?/i;

export const APPLICATION_APPROVED = 'approved';
export const APPLICATION_PENDING = 'pending';
export const APPLICATION_ERROR = 'error';
export const QUOTES_CODE = '&#39;';
export const AEM_CONTAINS_PHONE_NUMBER = '#phonenumber';
export const AEM_CONTAINS_EMAIL = '#mail';

export const CCA_FINALIZE = {
    ZERO: 0,
    ONE: 1
};

const isDevelopment = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
export const ERROR_SCREEN = `${window?.location?.protocol}//${window?.location?.host}/${
    isDevelopment
        ? 'content/sunbeltrentals/language-masters/en/cca/application-error.html?wcmmode=disabled'
        : 'cca/application-error/'
}`;

export const POD_ERROR_SCREEN = `${window?.location?.protocol}//${window?.location?.host}/${
    isDevelopment
        ? 'content/sunbeltrentals/language-masters/en/pod/application-error.html?wcmmode=disabled'
        : 'pod/application-error/'
}`;

export const EVENT_MODAL = 'modal';
export const MODAL_TYPE = {
    HELP: 'help',
    EXIT: 'exit',
    CCA_TIME_OUT: 'cca time-out',
    EXEMPTION: 'exemption',
    INFO: 'info',
    ADDRESS_VERIFY: 'address verify'
};

export const MANDATORY_BUSINESS_TYPE = [
    'Sole-Proprietorship',
    'Partnership'
]
